import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";
import { SearchTermsFilters, SearchTermsGridItem, SearchTermsGridResponse, OpportunityCardsResponse } from "./models";
import { PaginateQuery, SearchTermsFiltersQuery } from "./query";
import { GridFilterModel } from "@mui/x-data-grid";

const nonBrandedAPI = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL, credentials: 'include' }),
    reducerPath: 'api.nonBranded',
    tagTypes: ['nonBranded'],
    endpoints: (builder) => ({
        searchTermsFilters: builder.query<SearchTermsFilters, SearchTermsFiltersQuery>({
            query: (query) => ({
                url: '/non-branded/filters',
                method: 'GET',
                params: query,
            }),
        }),
        searchTermsGrid: builder.query<SearchTermsGridResponse, SearchTermsFiltersQuery & PaginateQuery & { filterModel?: GridFilterModel["items"] } >({
            query: (query) => {
                let url = '/non-branded/search_terms/grid';
                let params = [];
                if (query.countries.length > 0) {
                    params.push(`countries=${query.countries.join('&countries=')}`);
                }
                if (query.devices.length > 0) {
                    params.push(`devices=${query.devices.join('&devices=')}`);
                }
                if (query.platforms.length > 0) {
                    params.push(`platforms=${query.platforms.join('&platforms=')}`);
                }
                const limit = `&limit=${query.limit || 10}`
                const page = `&page=${query.page || 0}`
                const workspace_id = query.workspace_id ? `&workspace_id=${query.workspace_id}` : "";
                const start_date = query.start_date ? `&start_date=${query.start_date}` : "";
                const end_date = query.end_date ? `&end_date=${query.end_date}` : "";
                const filter_model = query.filterModel ? `&filter_model=${JSON.stringify(query.filterModel)}` : "";
                return ({
                    url: url + '?' + params.join('&') + limit + page + workspace_id + start_date + end_date + filter_model,
                    method: 'GET',
                })
            },
        }),
        opportunityCards: builder.query<OpportunityCardsResponse, SearchTermsFiltersQuery>({
            query: (query) => {
                let url = '/non-branded/search_terms/opportunity_cards';
                let params = [];
                if (query.countries.length > 0) {
                    params.push(`countries=${query.countries.join('&countries=')}`);
                }
                if (query.devices.length > 0) {
                    params.push(`devices=${query.devices.join('&devices=')}`);
                }
                if (query.platforms.length > 0) {
                    params.push(`platforms=${query.platforms.join('&platforms=')}`);
                }
                const workspace_id = query.workspace_id ? `&workspace_id=${query.workspace_id}` : "";
                const start_date = query.start_date ? `&start_date=${query.start_date}` : "";
                const end_date = query.end_date ? `&end_date=${query.end_date}` : "";
                return ({
                    url: url + '?' + params.join('&') + workspace_id + start_date + end_date,
                    method: 'GET',
                })
            },
        }),
    }),
});

export const { useSearchTermsFiltersQuery, useSearchTermsGridQuery, useOpportunityCardsQuery } = nonBrandedAPI;
export default nonBrandedAPI;